export interface RoutesReportControlRequest {
  idOrigin: number;
}

export enum pointTypeEnum {
  store = 1,
  city = 2,
  operationalArea = 3
}

export enum TypeRequestReportRouteEnum {
  storeToStore = 1,
  storeToOperationAreas = 2,
  cityToStore = 3,
  cityToOperationAreas = 4,
}

export interface fieldTypeDistanceReport<T> {
  title: string;
  getter: (obj: T) => string | number;
}

export interface typeDistanceReport<T> {
  type: TypeRequestReportRouteEnum;
  from: pointTypeEnum;
  to: pointTypeEnum;
  fields: fieldTypeDistanceReport<T>[];
  getOriginData: (ids: number[]) => Promise<T[]>;
  downloadReport: (obj: T) => Promise<any>;
}
